export enum NotificationType {
    Success = 0,
    Error = 1,
    Warning = 2,
    Info = 3
}

export enum NotificationPlacement {
    top = 'top',
    bottom = 'bottom',
    topLeft = 'topLeft',
    topRight = 'topRight',
    bottomLeft = 'bottomLeft',
    bottomRight = 'bottomRight'
}

export interface NotificationDescription {
    key?: string | undefined
    visible: boolean;
    notificationType: NotificationType;
    message?: string;
    description?: string;
    duration?: number;
    placement?: NotificationPlacement
}

export interface NotificationProps {
    message?: string,
    description?: string,
    duration?: number,
    placement?: NotificationPlacement
}
